export default {
  selectKf: "请选择客服",
  table: {
    name: "昵称",
    username: "用户名",
    avatar: "头像",
    introduction: "简介",
    status: "状态",
    totalConversation: "总会话数",
    finishConversation: "结束会话数",
    autoFinishConversation: "自动关闭会话数",
    avgResponseTime: "响应时长(min)",
    scoreCnt: "用户评分人数",
    scoreAvg: "平均用户评分",
    lastLoginAt: "最后登录时间",
    lastLogoutAt: "最后登出时间",
    createdAt: "创建时间",
    editTag: "编辑标签",
    export: "导出",
    respondedSessions: "响应会话数",
    isOnline: "在线状态",
  },
  message: {
    userNameLength: "用户名长度在 5 到 20 个字符",
    resetPasswordConfirmation: "你确定要重置 '{val}' 客服密码吗？",
  },
  form: {
    userName: "客服",
    roleId: "角色",
    tag: "标签",
  },
};
